import React from 'react';
// styles
import {
  DivStyledContainer,
  DivStyledDecorativeLineContainer,
  DivStyledTagContainer,
  PictureStyled,
  TypographyStyled,
} from './styles';

export default ({
  backgroundVariant,
  image,
  imageAlt,
  lastChild,
  tagText,
}) => {
  return (
    <DivStyledDecorativeLineContainer
      backgroundVariant={backgroundVariant}
      lastChild={lastChild}>
      <DivStyledContainer backgroundVariant={backgroundVariant}>
        <DivStyledTagContainer backgroundVariant={backgroundVariant}>
          <TypographyStyled
            variant='h3'
            weight={600}
            disableBottomPadding>
            {tagText}
          </TypographyStyled>
        </DivStyledTagContainer>
        <PictureStyled
          backgroundVariant={backgroundVariant}
          src={image}
          altText={imageAlt} />
      </DivStyledContainer>
    </DivStyledDecorativeLineContainer>
  );
};
